import { Pagination } from './pagination.model';

export interface ReceivableType {
  id: number;
  nome: string;
}

export interface ReceivableConsultationForm {
  cedente: string;
  dataAquisicao: string;
  dataVencimento: string;
  especie: string;
  id: number;
  sacado: string;
  novoVene: string;
  seuNumero: string;
  numeroDocumento: string;
  ocorrencia: string;
  situacao: string;
  status: number;
  valorAquisicao: number;
  valorAtual: number;
  valorLiquidacao: number;
  valorNominal: number;
}

export interface ReceivableConsultationTable
  extends Omit<ReceivableConsultationForm, 'status'> {
  status: string;
}

export interface ReceivablePagedTable extends Pagination {
  items: ReceivableConsultationTable[];
}

export interface Receivables {
  id: number;
  nome: string;
  geraBaixaAutomatica: boolean;
  aprovacaoAutomatica: boolean;
  fisico: boolean;
  contratoFisico: boolean;
  enviaOperacaoCartaoCredito: boolean;
  realizaCalculoCCB: boolean;
  diasValorizacaoVencido: number;
  pulaCertificadoraCustodianteAutPagamentoTED: boolean;
  pulaCertificadora: boolean;
  chaveAcesso: boolean;
  pagamentoTEDAgendada: boolean;
  tipoBaixa: any;
  vencimentoCCB: boolean;
  vencimentoDuplicata: boolean;
  marcacaoMercado: boolean;
  permitirSacadoAssinarComoRepresentante: boolean;
  validarSacadoApto: boolean;
  regisCCBCerc: boolean;
  rejeicaoPorContrato: boolean;
  stopAcrualPorContrato: boolean;
}

export interface RecebiveisPaged extends Pagination {
  recebiveis: Receivables[];
}
